var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, profiles, undefined) {
var length = profiles.length
if ( length > 0)
{
if ( length > 1)
{
buf.push("<div class=\"gpc-bumpers js-gpc-navigation\"><div class=\"gpc-bumper-prev gi-carousel-arrow-prev js-gpc-prev\"><i class=\"icon-chevron-left\"></i></div><div class=\"gpc-bumber-next gi-carousel-arrow-next js-gpc-next\"><i class=\"icon-chevron-right\"></i></div></div>");
}
buf.push("<div class=\"gpc-body\"><div class=\"gpc-overlays\">");
// iterate profiles
;(function(){
  var $$obj = profiles;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var profile = $$obj[i];

var show = profile.related().owner.related().shows.featured()
buf.push("<div" + (jade.attr("data-idx", i, true, true)) + " class=\"gpc-overlay js-gpc-overlay\"><a" + (jade.attr("href", profile.related().owner.href(), true, true)) + " class=\"gpc-headline\">" + (jade.escape(null == (jade_interp = profile.related().owner.get('name')) ? "" : jade_interp)) + "</a>");
if ( show)
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + "><div class=\"gpc-subheadline\">" + (jade.escape((jade_interp = show.statusLabel()) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = show.has('location') ? show.formatCity() : '') == null ? '' : jade_interp)) + " Show</div><div class=\"gpc-subheadline-alt\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</div><div class=\"gpc-location-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div></a>");
}
buf.push("<button" + (jade.attr("data-id", profile.id, true, true)) + " class=\"gpc-follow-button is-small avant-garde-follow-button-black follow-button js-follow-button\"></button></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var profile = $$obj[i];

var show = profile.related().owner.related().shows.featured()
buf.push("<div" + (jade.attr("data-idx", i, true, true)) + " class=\"gpc-overlay js-gpc-overlay\"><a" + (jade.attr("href", profile.related().owner.href(), true, true)) + " class=\"gpc-headline\">" + (jade.escape(null == (jade_interp = profile.related().owner.get('name')) ? "" : jade_interp)) + "</a>");
if ( show)
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + "><div class=\"gpc-subheadline\">" + (jade.escape((jade_interp = show.statusLabel()) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = show.has('location') ? show.formatCity() : '') == null ? '' : jade_interp)) + " Show</div><div class=\"gpc-subheadline-alt\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</div><div class=\"gpc-location-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div></a>");
}
buf.push("<button" + (jade.attr("data-id", profile.id, true, true)) + " class=\"gpc-follow-button is-small avant-garde-follow-button-black follow-button js-follow-button\"></button></div>");
    }

  }
}).call(this);

var index = 0
buf.push("<div class=\"mgr-dots\">");
if ( length > 1)
{
// iterate new Array(length)
;(function(){
  var $$obj = new Array(length);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-gpc-dot',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-gpc-dot',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  }
}).call(this);

}
buf.push("</div></div><div class=\"gpc-carousel\"><div class=\"gpc-carousel-cells js-mgr-cells\">");
// iterate profiles
;(function(){
  var $$obj = profiles;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var profile = $$obj[$index];

var show = profile.related().owner.related().shows.featured()
buf.push("<div class=\"gpc-carousel-cell js-mgr-cell\">");
if ( show && show.isWithImages())
{
var imageUrl = show.hasImage('featured') ? show.imageUrl('featured') : show.imageUrlForMaxSize()
}
else if ( profile.get('cover_image'))
{
var imageUrl = profile.coverImage().imageUrlForMaxSize()
}
else
{
var imageUrl = ''
}
buf.push("<a" + (jade.attr("href", (show && show.href()) || profile.related().owner.href(), true, true)) + (jade.attr("style", 'background-image: url(' + imageUrl + ')', true, true)) + " class=\"gpc-carousel-figure\"></a></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var profile = $$obj[$index];

var show = profile.related().owner.related().shows.featured()
buf.push("<div class=\"gpc-carousel-cell js-mgr-cell\">");
if ( show && show.isWithImages())
{
var imageUrl = show.hasImage('featured') ? show.imageUrl('featured') : show.imageUrlForMaxSize()
}
else if ( profile.get('cover_image'))
{
var imageUrl = profile.coverImage().imageUrlForMaxSize()
}
else
{
var imageUrl = ''
}
buf.push("<a" + (jade.attr("href", (show && show.href()) || profile.related().owner.href(), true, true)) + (jade.attr("style", 'background-image: url(' + imageUrl + ')', true, true)) + " class=\"gpc-carousel-figure\"></a></div>");
    }

  }
}).call(this);

buf.push("</div></div></div>");
}}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"profiles" in locals_for_with?locals_for_with.profiles:typeof profiles!=="undefined"?profiles:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;